<script setup lang="ts">
import type LxcError from "~/core/models/LxcError.class";

defineProps<{
  isLoading?: boolean;
  error?: LxcError | null;
  title?: string;
  bodyClass?: string;
  containerClass?: string;
  loaderContainerClass?: string | string[];
}>();
</script>

<template>
  <lxc-card class="card-body h-full" :body-class="bodyClass" shadow>
    <h4 v-if="title" class="text-gray-700 mb-6">
      {{ title }}
    </h4>

    <container-component
      :class="containerClass"
      :error="error"
      :is-loading="isLoading"
      :loader-container-class="loaderContainerClass"
      :loader-size="20"
      :px="0"
      :py="0"
    >
      <slot />
    </container-component>
  </lxc-card>
</template>
